import { en } from 'vuetify/lib/locale'

export default {
  $vuetify: {
    ...en,
  },
}
